<template>
  <div>
    <ExceptionalClosure
      :exceptions="exceptions"
      @clickCanceled="$emit('clickCanceled', $event)"
      @input="$emit('change', $event)"
      @removeExceptionalEvent="$emit('removeExceptionalEvent', $event)"
      :subtitle="$t('exceptionalClosureService.subtitle')"
      :title="$t('exceptionalClosureService.title')"
    />
  </div>
</template>

<script>
import ExceptionalClosure from '@/components/settings/ExceptionalClosure'

export default {
  name: 'ExceptionalClosureService',

  components: { ExceptionalClosure },

  model: {
    prop: 'exceptions',
    event: 'change'
  },

  props: {
    exceptions: {
      type: Array,
      required: true
    }
  }
}
</script>
